export default __webpack_public_path__ + "static/media/startuplinks.ece31171.png";